import React from 'react';
import classNames from 'classnames';
import { Fade } from 'react-awesome-reveal';
import { Paragraph } from '@uncinc/react-drupal-core';
import { Image } from '@uncinc/uncinc-react-kitchen-sink';

import {
  Container,
  WysiwygField,
  PatternBlock,
  Button,
  Breadcrumbs,
} from '../../../../components';

import {
  SCREEN_MOBILE,
  SCREEN_TABLET,
  SCREEN_NORMAL,
} from '../../../../config/constants';

import './style.scss';

const NodeLandingPageFull = ({ entity, className }) => {
  let hero = false;
  let videoHeader = false;
  let filteredElements = entity.getIn(['field_paragraphs']);

  entity.get('field_paragraphs').forEach((element, i) => {
    if (element.getIn(['entity', 'type', 0, 'target_id']) === 'hero') {
      hero = element;
      filteredElements = entity.getIn(['field_paragraphs']).delete(i);
    }
    if (element.getIn(['entity', 'type', 0, 'target_id']) === 'video_header') {
      videoHeader = element;
      filteredElements = entity.getIn(['field_paragraphs']).delete(i);
    }
  });

  const heroLink = entity.getIn(['field_link', 0, 'uri']);
  const heroLinkTitle = entity.getIn(['field_link', 0, 'title']);
  const linkRel = entity.getIn(['field_link', 0, 'options', 'attributes', 'rel']);
  const heroImageMobile = entity.getIn(['field_image', 0, 'styles', 'homepage_hero_mobile'], null);
  const heroImageTablet = entity.getIn(['field_image', 0, 'styles', 'hero_tablet'], null);
  const heroImageDesktop = entity.getIn(['field_image', 0, 'styles', 'hero_desktop'], null);

  let button;
  if (heroLink && heroLinkTitle) {
    button = <Button secondary withIcon buttonIcon href={heroLink}>{heroLinkTitle}</Button>;
  }

  const classes = classNames(className, 'LandingPage', {
    'extra-padding': (linkRel && linkRel === 'doe-je-mee'),
  });

  return (
    <article typeof="schema:WebPage" className={classes}>
      {heroImageDesktop &&
        <div className="LandingPage__hero">
          <Image
            className="LandingPage__hero__image"
            lazyload={false}
            src={{
              [SCREEN_MOBILE]: heroImageMobile,
              [SCREEN_TABLET]: heroImageTablet,
              [SCREEN_NORMAL]: heroImageDesktop,
            }}
            includeWebP
          />
        </div>}
      {hero && !heroImageDesktop && (
        <Paragraph id={hero.get('target_id')} />
      )}
      {!hero && videoHeader && !heroImageDesktop && (
        <Paragraph id={videoHeader.get('target_id')} />
      )}

      {(!entity.get('is_front', false) || entity.getIn(['body', 0, 'processed'])) && !videoHeader && (
        (heroImageDesktop || hero) ? (
          <Container>
            <div className="row">
              <div className="col-12 col-lg-8 offset-lg-2">
                <PatternBlock className="LandingPage LandingPage__intro">
                  {!entity.get('is_front', false) ? (
                    <Fade triggerOnce bottom distance="50px" duration={500}>
                      <h1 className="LandingPage__title page-header">{entity.getIn(['title', 0, 'value'])}</h1>
                    </Fade>
                  ) : null}
                  {entity.getIn(['body', 0, 'processed']) ? (
                    <WysiwygField
                      property="schema:text"
                      className="LandingPage__body"
                      html={entity.getIn(['body', 0, 'processed'], '')}
                    />
                  ) : null}
                  {button}
                </PatternBlock>
              </div>
            </div>
          </Container>
        ) : (
          <>
            <Container>
              <Breadcrumbs includeCurrent />
            </Container>
            <Container>
              <div className="row">
                <div className="col-12 col-lg-8 offset-lg-2">
                  <div className="LandingPage">
                    {!entity.get('is_front', false) ? (
                      <Fade triggerOnce bottom distance="50px" duration={500}>
                        <h1 className="LandingPage__title page-header">{entity.getIn(['title', 0, 'value'])}</h1>
                      </Fade>
                    ) : null}
                    {entity.getIn(['body', 0, 'processed']) ? (
                      <WysiwygField
                        property="schema:text"
                        className="LandingPage__body"
                        html={entity.getIn(['body', 0, 'processed'], '')}
                      />
                    ) : null}
                    {button}
                  </div>
                </div>
              </div>
            </Container>
          </>
        )
      )}

      <div className="Paragraphs">
        {
          filteredElements.map((item, index) => {
            const paragraphId = item.get('target_id');
            const paragraph = item.getIn(['entity']);
            return (
              <Paragraph key={paragraphId} entity={paragraph} id={paragraphId} />
            );
          })
        }
      </div>
    </article>
  );
};

export default NodeLandingPageFull;

